const state = {
    language: 'en',
    languages: [
        {flag: 'us', language: 'en', title: 'English'},
        {flag: 'eth', language: 'አማ', title: 'አማርኛ'},
        {flag: 'eth', language: 'ኦሮ', title: 'Oromiffa'},
        {flag: 'eth', language: 'ትግ', title: 'ትግርኛ'},
      ]

};

const getters = {
    getLocale: state => {
        return state.language
    },
    getLanguages: state => state.languages 
};

const mutations = {
    changeLocale: (state,payload) => {
        state.language = payload;
    }
};

const actions = {
    changeLocale: ({ commit },payload) => {
        commit('changeLocale',payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
